import { resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02382c7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "safecheck" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "统计", -1))
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "检查记录", -1))
const _hoisted_6 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_van_tabbar_item = _resolveComponent("van-tabbar-item")!
  const _component_van_tabbar = _resolveComponent("van-tabbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      placeholder: "",
      title: _ctx.$route.meta.title,
      "left-arrow": "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_view, null, {
        default: _withCtx(({ Component }) => [
          _createVNode(_Transition, {
            name: "fade",
            mode: "out-in"
          }, {
            default: _withCtx(() => [
              (_openBlock(), _createBlock(_KeepAlive, null, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
              ], 1024))
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_van_tabbar, {
      "inactive-color": "#949CA1",
      "active-color": "#1D5A93",
      placeholder: "",
      route: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_tabbar_item, {
          replace: "",
          to: "/app/safecheck/tongji"
        }, {
          icon: _withCtx((props) => [
            _createElementVNode("img", {
              src: 
              props.active
                ? require('@/assets/anquanjiancha/tongji-a.png')
                : require('@/assets/anquanjiancha/tongji.png')
            
            }, null, 8, _hoisted_4)
          ]),
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createVNode(_component_van_tabbar_item, {
          replace: "",
          to: "/app/safecheck/checkrecord"
        }, {
          icon: _withCtx((props) => [
            _createElementVNode("img", {
              src: 
              props.active
                ? require('@/assets/anquanjiancha/jilu-a.png')
                : require('@/assets/anquanjiancha/jilu.png')
            
            }, null, 8, _hoisted_6)
          ]),
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}